export enum PathsEnum {
  root = '/',
  down = '/service-unavailable',

  // user login/ logout
  login = '/login',
  logout = '/logout',

  home = '/noaccess-found',

  // account
  account = '/:tntId/account',
  accountNew = 'new',
  accountForgotPassword = 'forgot-password',
  accountResetPassword = 'reset-password',
  // settings and admin center
  accountSettings = 'settings',
  accountSettingsProfile = 'profile',
  accountSettingsOrg = 'organization',
  accountSettingsCalls = 'calls',
  accountSettingsGroups = 'groups',
  accountSettingsUsers = 'users',
  accountSettingsAutoCheck = 'autocheck',
  accountSettingsSecurity = 'security',
  accountSettingsDiagnostic = 'diagnostics',
  accountSettingsColumns = 'columns',
  accountSettingsSampleData = 'sample-data',
  accountSettingsDataMaps = 'data-maps',

  // data handling
  dataHandling = '/:tntId/data-handling',
  fileUpload = 'file-upload',
  newClaimForm = 'new-claim-form',

  // analytics
  analytics = '/:tntId/analytics',

  // files center
  filesCenter = '/:tntId/files-center',

  // file-share
  fileShare = '/:tntId/file-share',
  fileShareFiles = 'files',

  // claims
  claims = '/:tntId/claims',
  batch = '/:tntId/batch',
  claimFile = 'claim-file',
  batchUpload = 'batch-upload',
  batchProcessing = 'batch-processing',
  batchProcessed = 'batch-processed',
  batchAwaiting = 'batch-awaiting',
  batchArchive = 'batch-archive',
  batchPending = 'batch-pending',
  eobReview = 'eob-review',
  unSupportedFax = 'unsupported-fax',
  claimBatch = 'batch',
  claim = 'claim',
  call = 'calls',
  claimsBatch = 'batch/:batchId',
  claimDetails = 'claim/:oaiClaimId',
  claimsCall = 'calls/:callId',
  claimsCallSummary = 'calls-summary/:callId',
  callsSummary = 'calls-summary',

  /**
   * Claim Queued tabs
   */
  needsWork = 'needs-work',
  onLiveCall = 'on-live-call',
  queuedCall = 'queued',
  archived = 'archived',

  // other
  other = '*',
}

export enum PathsVariablesEnum {
  tntId = ':tntId',
  oaiClaimId = ':oaiClaimId',
  callId = ':callId',
}

type PathVariablesType = {
  [key in PathsVariablesEnum]?: string
}

const replacePathVariables = (path: PathsEnum, options: PathVariablesType): string => {
  const re = new RegExp(Object.keys(options).join('|'), 'gi')
  return path.replace(re, (matchedVariable: string) => {
    return options[matchedVariable as PathsVariablesEnum] as string
  })
}

export const paths = {
  claim: (claimId: string) => `${PathsEnum.claims}/${claimId}`,
  claimsCall: (claimId: string, callId: string) =>
    `${PathsEnum.claims}/${replacePathVariables(PathsEnum.claimsCall, {
      [PathsVariablesEnum.callId]: callId,
      [PathsVariablesEnum.oaiClaimId]: claimId,
    })}`,
  claimsCallSummary: (claimId: string, callId: string) =>
    `${PathsEnum.claims}/${replacePathVariables(PathsEnum.claimsCallSummary, {
      [PathsVariablesEnum.oaiClaimId]: claimId,
      [PathsVariablesEnum.callId]: callId,
    })}`,
  settingsDiagnostic: `${PathsEnum.account}/${PathsEnum.accountSettings}/${PathsEnum.accountSettingsDiagnostic}`,
}
